/* @flow */
import type { Target, GroupTarget, GroupChatTarget, OrganizationTarget } from 'entities/Message';
import { TARGET_TYPES } from 'entities/Message';
import invariant from 'invariant';
import GroupStore from 'groups/stores/GroupStore';
import ChatStore from 'chat/stores/ChatStore';

export default function(target: Target): ?string {
  switch (target.type) {
    case TARGET_TYPES.ORGANIZATION_TARGET: {
      const orgTarget: OrganizationTarget = target;
      invariant(orgTarget.org_id, 'missing org_id in handleComposerSent');
      const staffClass = GroupStore.getStaffClassForOrg(orgTarget.org_id);
      invariant(staffClass, 'missing group in handleComposerSent');
      const staffClassCode = staffClass.getCodeOrError();
      return `/classes/${staffClassCode}/messages/stream`;
    }

    case TARGET_TYPES.GROUP_TARGET: {
      const groupTarget: GroupTarget = target;
      invariant(groupTarget.group_id, 'missing group_id in handleComposerSent');
      const group = GroupStore.getGroup(groupTarget.group_id);
      invariant(group, 'missing group in handleComposerSent');
      const groupCode = group.getCodeOrError();
      return `/classes/${groupCode}/messages/stream`;
    }

    case TARGET_TYPES.GROUP_CHAT_TARGET: {
      const groupChatTarget: GroupChatTarget = target;
      invariant(groupChatTarget.uuid, 'missing group chat uuid in handleComposerSent');
      return `/classes/r/messages/${groupChatTarget.uuid}`;
    }

    case TARGET_TYPES.INDIVIDUAL_TARGET: {
      // VisualComposer gets the chat UUID from the response and puts it in ChatStore.
      const chatId = ChatStore.getCurrentChatId();
      invariant(chatId, 'missing chat id in handleComposerSent');
      return `/classes/r/messages/${chatId}`;
    }

    default:
      return null;
  }
}
